<template>
    <div>
        <TDSError v-if="error" :message="error"></TDSError>
        <form @submit.prevent="flagUser">
            <div class="flex-row mb-4" :class="{disabled: isBusy}">
                <SelectField label="Add Flag To User"
                             :options="flags"
                             name-key="flagName"
                             val-key="flagName"
                             @change="onSelectFlag"/>
                <TDSButton button-style="primary-red"
                           width="10%"
                           :inactive="!selectedFlag"
                           :show-spinner="isBusy"
                           :class="{'mt-5': !isMobile}">
                    Add Flag
                </TDSButton>
            </div>
        </form>
        <div class="flags mb-2">
            <span class="badge no-hover mr-2 mb-2"
                  v-for="flag in usersFlags"
                  :key="flag.flagName">
                {{ flag.flagName }}
                <img src="../../../assets/icons/delete-grey.svg"
                     alt="delete flag"
                     @click="deleteFlagFromUser(flag.flagName)">
            </span>
            <div class="mt-4" style="opacity: 0.5; text-align: center" v-if="usersFlags.length === 0">User has no flags...</div>
        </div>
    </div>
</template>

<script lang="ts">
import {Component, Prop} from "vue-property-decorator";
import {VueClassTemplate} from "@/util/VueClassTemplate";
import DefaultCard from "../DefaultCard.vue";
import InputField from "@/components/common/InputField.vue";
import TDSButton from "@/components/common/TDSButton.vue";
import {DentUser} from "@/interfaces/entities/DentUser";
import {GetUserFlagsResponse} from "@/interfaces/httpResponses/GetUserFlagsResponse";
import SelectField from "@/components/common/SelectField.vue";
import TDSError from "@/components/common/TDSError.vue";

@Component({
    components: {DefaultCard, InputField, TDSButton, SelectField, TDSError}
})
export default class FlagUserForm extends VueClassTemplate {

    @Prop() user!: DentUser;

    flags: {flagName: string}[] = [];
    usersFlags: {flagName: string}[] = [];
    selectedFlag: string = "";

    async init() {
        this.startProgress("loading");
        try {
            const userFlags: GetUserFlagsResponse = await this.$store.dispatch("FETCH_USER_FLAGS");
            this.flags = userFlags.flags.map((flagName: string) => ({ flagName }));

            this.usersFlags = (await this.$store.dispatch("FETCH_USERS_FLAGS", this.user.login)).flags;
        } catch(e) {
            this.error = "<b>Error while loading user flags:</b><br>" + e.message;
        }
        this.endProgress("loading");
    }

    onSelectFlag(flagName: string) {
        this.selectedFlag = flagName;
    }

    async flagUser() {
        this.startProgress("flagging");
        try {
            await this.$store.dispatch("ADD_FLAG_TO_USER", {
                flagName: this.selectedFlag,
                username: this.user.login
            });
            await this.init();
        } catch(e) {
            this.error = "<b>Error while adding flag to user:</b><br>" + e.message;
        }
        this.endProgress("flagging");
    }

    async deleteFlagFromUser(flagName: string) {
        this.startProgress("removing_flag");
        try {
            await this.$store.dispatch("DELETE_FLAG_FROM_USER", {
                flagName, username: this.user.login
            });
            await this.init();
        } catch(e) {
            this.error = "<b>Error while deleting flag from user:</b><br>" + e.message;
        }
        this.endProgress("removing_flag");
    }
}
</script>

<style lang="scss" scoped>
.flags {
    min-height: 23px;
}
</style>
